export default __webpack_public_path__ + "static/media/843.a95c3736.png";